import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../app/store';

export interface PollingConfiguration {
  identifier: string;
  interval: number;
  intervalId?: number;
  params?: any;
}

export interface PollingState {
  pollingConfigurations: PollingConfiguration[];
  isPolling: boolean;
}

const initialState: PollingState = {
  pollingConfigurations: [],
  isPolling: false,
};

const pollingSlice = createSlice({
  name: 'polling',
  initialState,
  reducers: {
    addPollingConfiguration: (state, action: PayloadAction<PollingConfiguration>) => {
      const pollingExists = state.pollingConfigurations.find(
        (config) => config.identifier == action.payload.identifier,
      );
      if (pollingExists) return;
      state.pollingConfigurations.push(action.payload);
    },
    addIntervalId: (state, action: PayloadAction<{ identifier: string; intervalId: number }>) => {
      const config = state.pollingConfigurations.find((config) => config.identifier === action.payload.identifier);
      if (config) {
        config.intervalId = action.payload.intervalId;
      }
    },
    removePollingConfiguration: (state, action: PayloadAction<{ pollingConfigId: string }>) => {
      const pollingsToRemove = state.pollingConfigurations.filter(
        (config) => config.identifier === action.payload.pollingConfigId,
      );
      pollingsToRemove.forEach((config) => {
        clearInterval(config.intervalId);
      });
      state.pollingConfigurations = state.pollingConfigurations.filter(
        (config) => config.identifier !== action.payload.pollingConfigId,
      );
    },
    setIsPolling: (state, action: PayloadAction<boolean>) => {
      state.isPolling = action.payload;
    },
    setIntialPollingState: (state) => {
      state.pollingConfigurations.forEach((config) => {
        clearInterval(config.intervalId);
      });
      state.pollingConfigurations = [];
      state.isPolling = false;
    },
  },
});

export const {
  addPollingConfiguration,
  removePollingConfiguration,
  addIntervalId,
  setIsPolling,
  setIntialPollingState,
} = pollingSlice.actions;

export const selectPollingConfigurations = (state: RootState) => state.polling;

export default pollingSlice.reducer;
